import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/lib/supabaseClient';
import { toast } from 'sonner';

interface AffiliatePaymentResponse {
  success: boolean;
  checkout_url?: string;
  message?: string;
}

export function useAffiliatePayment() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (): Promise<AffiliatePaymentResponse> => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) throw new Error('Not authenticated');

      const response = await fetch(
        `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/affiliate-payment`,
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${session.access_token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Failed to process affiliate payment');
      }

      return response.json();
    },
    onSuccess: (data) => {
      if (data.checkout_url) {
        // Redirect to Stripe checkout
        window.location.href = data.checkout_url;
      } else if (data.success) {
        toast.success('Payment successful! You now have access to referral tools.');
        // Invalidate referral stats to refresh the UI
        queryClient.invalidateQueries({ queryKey: ['referral-stats'] });
      }
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });
}